import { Component } from "react";
import Box from '@mui/material/Box';
import DashboardApi from "../../../api/DashboardApi";
import ProfileContext from "./IndicatorsContext";
import { Trans } from "react-i18next";
import ProfileHeader from "../../../components/ProfileHeader";
import ProfileBottomNav from "../../../components/ProfileBottomNav";
import PendingDeliveriesCard from "./PendingDeliveriesCard";
import OverdueDocumentsCard from "./OverdueDocumentsCard";
import VehiclesCard from "./VehiclesCard";
import { getSessionStorage } from "../../../utils/StorageUtil";
import { USER_SO_KEY } from "../../../utils/accountUtils";
import CircularProgress from '@mui/material/CircularProgress';

type Props = {};

type State = {
  timesChanged: number
}

export default class extends Component<Props, State> {

  constructor(props: Props) {
    super(props)
    this.state = { timesChanged: 0 }
  }



  render() {
    const user = getSessionStorage(USER_SO_KEY);
    return (
      <ProfileContext.Consumer>
        { context => {
          if (!context.indicators) {
            DashboardApi.get()
              .then(it => context.indicators = it.data)
              .then(() => this.setState({ timesChanged: this.state.timesChanged+1 }))
            return (<Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="100vh"
            > <CircularProgress  size={100} />
            </Box>)
          }

          return (
            <Box sx={{background: '#F2F3F1'}}>
              <ProfileHeader></ProfileHeader>
              <Box sx={{margin: '0 4%', mb: 10}}>
                <Box className="indicators-title"><Trans i18nKey={`screens.indicators.title`}></Trans></Box>
                      { (user.role==='OPERATIVO' || user.role==='LIDER_BASE') && (
							        	 <Box className="indicators-title">Base {user?.base?.name}</Box>
									) }
									 { ( user.role==='RESPONSABLE_FLOTA') && (
							 	 <Box className="indicators-title">Cliente {user?.company?.name}</Box>
									)
                                     }


                { context.indicators.pendingDeliveries.length > 0 && (<PendingDeliveriesCard/>)}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3, // espacio vertical entre cards
                    mt: 3, // margen superior
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: 3,
                      boxShadow: "0px 2px 10px rgba(0,0,0,0.08)",
                      p: 2,
                    }}
                  >
                    <VehiclesCard />
                  </Box>

                  <Box
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: 3,
                      boxShadow: "0px 2px 10px rgba(0,0,0,0.08)",
                      p: 2,
                    }}
                  >
                    <OverdueDocumentsCard />
                  </Box>
                </Box>
              </Box>
              <ProfileBottomNav search={true} ></ProfileBottomNav>
            </Box>
          )
        }}
      </ProfileContext.Consumer>
    );
  }
}
